import httpCommon from "./http-common";

// Get all notes for a customer
const getNotesByCustomer = (customerId: number) => {
  return httpCommon.get(`/v1/get/notes/customer/${customerId}`);
};

// Get all notes for a deal
const getNotesByDeal = (dealId: number) => {
  return httpCommon.get(`/v1/get/notes/deal/${dealId}`);
};

// Create note
const createNote = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/note/${businessId}`, data);
};

// Update note
const updateNote = (noteId: number, data: any) => {
  return httpCommon.put(`/v1/update/note/${noteId}`, data);
};

// Delete note
const deleteNote = (noteId: number) => {
  return httpCommon.delete(`/v1/delete/note/${noteId}`);
};

const NoteService = {
  getNotesByCustomer,
  getNotesByDeal,
  createNote,
  updateNote,
  deleteNote
};

export default NoteService; 